// extracted by mini-css-extract-plugin
export default {"modalOverlay":"styles_modalOverlay__Ojkda","modalContent":"styles_modalContent__JxeyM","header":"styles_header__MI7l1","form":"styles_form__D7oTx"};